module.exports = __webpack_public_path__ + "img/feature-inscricao-digital.83eee1a3.svg";